import type { ReactNode } from 'react';

export const symbol_swipe_right_alt: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M360-280q-83 0-141.5-58.5T160-480q0-83 58.5-141.5T360-680q82 0 133.5 50.5T559-510h207l-68-68q-9-9-9-21t9-21q9-9 21-9t21 9l119 119q5 5 7 10t2 11q0 6-2 11t-7 10L740-340q-9 9-21 9t-21-9q-9-9-9-21t9-21l68-68H559q-14 69-65.5 119.5T360-280Zm99-101q41-41 41-99t-41-99q-41-41-99-41t-99 41q-41 41-41 99t41 99q41 41 99 41t99-41Zm-99-99Z"
		/>
	</svg>
);
